export default __webpack_public_path__ + "static/media/base-report22.e70a5014.png";